import { render, staticRenderFns } from "./DeathCertificate.vue?vue&type=template&id=654341a4&scoped=true&"
import script from "./DeathCertificate.vue?vue&type=script&lang=js&"
export * from "./DeathCertificate.vue?vue&type=script&lang=js&"
import style0 from "./DeathCertificate.vue?vue&type=style&index=0&id=654341a4&prod&lang=less&scoped=true&"
import style1 from "./DeathCertificate.vue?vue&type=style&index=1&id=654341a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654341a4",
  null
  
)

export default component.exports